import { Injectable, Renderer2 } from '@angular/core';
import { CompanyCustomizationsService } from '@core/services/customization/customizations.service';

@Injectable({
  providedIn: 'root'
})
export class AppendCustomCodeService {
  private renderer!: Renderer2;
  constructor(private customizations: CompanyCustomizationsService) {}

  injectCustomCode(renderer: Renderer2): void {
    this.renderer = renderer;
    const custom = this.customizations.getCustomizations();
    const headCode: string = custom.CUSTOM_HEAD_CODE;
    const bodyCode: string = custom.CUSTOM_BODY_CODE;

    this.injectHtmlToTarget(headCode, document.head);
    this.injectHtmlToTarget(bodyCode, document.body, true);
  }

  private injectHtmlToTarget(htmlCode: string, targetElement: HTMLHeadElement | HTMLElement, isBody = false): void {
    if (!htmlCode?.trim()) {
      return;
    }

    const tempDiv: HTMLDivElement = this.renderer.createElement('div');
    tempDiv.innerHTML = htmlCode.trim();

    const otherElements: HTMLCollection = tempDiv.children;

    this.appendRestOfElements(targetElement, otherElements, isBody);
  }

  private appendElement(elementName: string, element: Element, targetElement: HTMLHeadElement | HTMLElement): void {
    const newElement: HTMLScriptElement = this.renderer.createElement(elementName);
    Array.from(element.attributes).forEach((attr: Attr) => {
      this.renderer.setAttribute(newElement, attr.name, attr.value);
    });
    newElement.textContent = element.textContent;
    this.renderer.appendChild(targetElement, newElement);
  }

  private appendRestOfElements(
    targetElement: HTMLHeadElement | HTMLElement,
    otherElements: HTMLCollection,
    isBody = false
  ): void {
    Array.from(otherElements).forEach((element) => {
      if (element.tagName?.toLowerCase() === 'script' || element.querySelector('script')) {
        this.appendElement('script', element, targetElement);
      } else if (element.tagName?.toLowerCase() === 'style' || element.querySelector('style')) {
        this.appendElement('style', element, targetElement);
      } else {
        if (isBody && element.id === 'app-custom-header-element') {
          const headerEl = document.getElementById('app-custom-header-placeholder');
          if (headerEl) {
            this.renderer.appendChild(headerEl, element);
          }
        } else if (isBody && element.id === 'app-custom-footer-element') {
          const footerEl = document.getElementById('app-custom-footer-placeholder');
          if (footerEl) {
            this.renderer.appendChild(footerEl, element);
          }
        } else {
          this.renderer.appendChild(targetElement, element);
        }
      }
    });
  }
}
